<template>
  <v-row justify="center">
    <v-dialog
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-card-title class="pl-4 pr-4 ">Update Payment Method</v-card-title>
        <v-card-text class="body-1 mb-0 pb-0 pl-4 pr-4 mb-1">
          <div class="d-flex justify-end payment-icons">
            Supported Cards:
            <v-spacer />
            <img
              max-height="15px"
              width="40px"
              contain=""
              :src="cards.visa"
              class="ml-1"
            />
            <img
              max-height="15px"
              width="40px"
              contain=""
              :src="cards.discover"
              class="ml-1"
            />
            <img
              max-height="15px"
              width="40px"
              contain=""
              :src="cards.mastercard"
              class="ml-1"
            />
            <img
              max-height="15px"
              width="40px"
              contain=""
              :src="cards.american"
              class="ml-1"
            />
          </div>
        </v-card-text>
        <stripecard @success="onSuccess" :key="refresh">
          <template v-slot:actionslot="{ click, loading, finished }">
            <v-card-text class="mb-0 pb-0 pt-0 mt-0">
              <span class="caption"
                >By clicking "Add Card" you are agreeing to our
                <a target="__terms__" href="https://arist.co/terms"
                  >Terms of Service</a
                ></span
              >
            </v-card-text>
            <v-card-actions>
              <v-btn color="grey" text @click="$emit('input', false)"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="blue"
                @click="click"
                :disabled="loading || finished"
                depressed
                :loading="loading"
                class="white--text"
                >Add Card</v-btn
              >
            </v-card-actions>
          </template>
        </stripecard>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style scoped>
.payment-icons img {
  height: 22px;
  object-fit: contain;
}
</style>
<script>
import stripecard from "../stripe-card";
export default {
  components: {
    stripecard
  },
  data: () => ({
    refresh: 0
  }),
  props: ["value", "header"],
  methods: {
    onSuccess() {
      this.$emit("success");
    }
  },
  watch: {
    value() {
      this.refresh = this.refresh + 1;
    }
  },
  computed: {
    cards() {
      return {
        visa: require("@/assets/imgs/paymenticons/visa.png"),
        discover: require("@/assets/imgs/paymenticons/discover.png"),
        mastercard: require("@/assets/imgs/paymenticons/mastercard.png"),
        american: require("@/assets/imgs/paymenticons/american.png")
      };
    }
  }
};
</script>

<style></style>
